<template>
    <div class="account-container" style="margin-top: 80px;">
      <img src="/3d/static/images/login_head00.png" style="margin-top: -80px;height: 250px;">
        <ul class="account-info-inpus" v-show="true">
            <li class="col-12-li" style="display: none;"><commonInputsTitle returnText="" tkey="登錄">{{i18n.tkey("lang_login")}}</commonInputsTitle></li>
            <li class="col-9-li">
              <loginTextInput classType="text-input2" v-model="loginSubmitObj.login.value" :disabled="waitPost" :placeholder="i18n.tkey('lang_login_email')" style="margin-top: 20px;margin-bottom: 10px;background-color: #90bfa9;" />
            </li>
            <li class="col-9-li"><loginPasswordInput v-model="loginSubmitObj.password.value" :disabled="waitPost" classType="text-input2" :placeholder="i18n.tkey('lang_password')" style="margin-top: 20px;margin-bottom: 30px; background-color: #90bfa9;" /></li>
            <li class="col-9-li"><el-button @click="clickSubmitBtn" color="#009688" type="primary"  :loading="waitPost" style="width: 100%;padding: 10px;font-size: 18px;height:50px;" tkey="登錄">{{i18n.tkey("lang_login")}}</el-button></li>
<!--            <li class="col-9-li" style="margin-top: 30px; margin-bottom: 50px"><a :href="signupUrl" target="eshopopee"><el-button type="primary" size="large" tkey="免費註冊">{{i18n.tkey('lang_free_registration')}}</el-button></a></li>-->
            <li class="col-9-li" style="margin-top: 30px; margin-bottom: 50px;"><el-button type="primary" size="large" @click="goClickGoSignupBtn" tkey="免費註冊" style="width: 100%;height: 50px;">{{i18n.tkey('lang_free_registration')}}</el-button></li>

        </ul>

        <!--    新用戶首次登錄時初始化資料    -->
        <el-dialog
            v-model="initAccountVisible"
            :title="i18n.tkey('lang_default_user_info_alert')"
            :width="'95%'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
        >
            <InitAccountInfo @save-complete="saveCallback" />
        </el-dialog>
    </div>
</template>

<script setup>
import {getCurrentInstance, onMounted, ref, reactive, computed, toRef, inject} from 'vue'
import { useUserinfo } from '@/stores/userinfo'
import { useCardinfo } from '@/stores/cardinfo'
import { ElMessage } from 'element-plus'
import commonInputsTitle from '@/components/commonInputsTitle.vue'
import loginTextInput from '@/components/loginTextInput.vue'
import loginPasswordInput from '@/components/loginPasswordInput.vue'
import util from "@/util/util"
import api from "@/request/api"
import userApi from "@/request/userApi"
import cookie from "@/util/cookie"
import myUtil from "@/util/util";
import {usePageinfo} from "@/stores/pageinfo";
import {useAdmininfo} from "@/stores/adminInfo";
import InitAccountInfo from "@/components/shopopee/login/initAccountInfo.vue";

let { proxy } = getCurrentInstance();
const userinfo = useUserinfo()
const userInfoRef = toRef(userinfo)
const cardInfoRef = toRef(useCardinfo())
const pageInfoRef = toRef(usePageinfo())
const adminInfoRef = toRef(useAdmininfo())

const i18n = inject("i18n")

const props = defineProps(['autoLogin'])
const emits = defineEmits(['login-check-complete', 'clickGoSignup', 'clickGoSendVCode', "clickReActivate"])
const initAccountVisible = ref(false)

const loginSubmitObj = reactive({
    login: {
        value: "",
        placeholder: i18n.tkey("lang_login_email"),
        type: "text",
        col: 4
    },
    password: {
        value: "",
        placeholder: i18n.tkey("lang_password"),
        type: "password",
        col: 4,
        useShowToggle: true
    }
})
const waitPost = ref(false)
const signupUrl = computed(() => {
    if (null != userInfoRef.value.invCode && "" !== userInfoRef.value.invCode){
        return `${proxy.$ShopopeeUrl}account_page?operation=signup&promotion=${userInfoRef.value.invCode}`
    }else{
        return `${proxy.$ShopopeeUrl}account_page?operation=signup`
    }
})

async function shopopeeLogin(login, password, callback) {
    const request = userApi.login
    const params = request.getParams()
    params.login = login
    params.password = password

    request.send(params, (res) => {
        // if (res.code == 200){
            if (typeof callback === "function"){
                callback(res)
            }
        // }else{
        //     if (typeof callback === "function"){
        //         callback(null)
        //     }
        // }
        waitPost.value = false
    })
}

function checkShopopeeCheck(){
    // const datetime = new Date().getTime()
    let timenum = 82800000

    // if(null == userInfoRef.value.lastOnlineDate) {
    //     timenum = datetime - userInfoRef.value.lastOnlineDate
    // }

    const cookieObj = cookie.getCookie()

    // if (null == userInfoRef.value.login && null != cookieObj.login){
    //     userInfoRef.value.login = cookieObj.login
    // }
    //
    // if (null == userInfoRef.value.password && null != cookieObj.password){
    //     userInfoRef.value.password = cookieObj.password
    // }

    let newAccountFlag = false

    if (null != cookieObj.login && userInfoRef.value.login != cookieObj.login){
        newAccountFlag = true
    }

    if (null != cookieObj.login){
        userInfoRef.value.login = cookieObj.login
    }

    if (null != cookieObj.password){
        userInfoRef.value.password = cookieObj.password
    }

    if (timenum >= 82800000 || newAccountFlag){
        if (myUtil.isNotEmpty(userInfoRef.value.login)&&myUtil.isNotEmpty(userInfoRef.value.password) ){
            if (myUtil.isNotEmpty(adminInfoRef.value.login)){
                myUtil.loadAdminMemberInfo(userInfoRef.value, adminInfoRef.value)
            }
            shopopeeLogin(userInfoRef.value.login, userInfoRef.value.password, shopopeeLoginCallback)
        }else{
            userInfoRef.value.memberStatus = 0
            emits("login-check-complete", 0)
        }
    }

}

function shopopeeLoginCallback(detail){
    if (null != detail){
        if (detail.code === 200){
            const dateNow = new Date().getTime()

            const optionObj = {
                memberStatus: -1,
                id: null,
                acccompanycode: null,
                addinfo2: null,
                addinfo3: null,
                addinfo6: null,
                addinfo7: null,
                companycode: null,
                companyname: null,
                companyname2: null,
                wa: null,
                siojournal: null,
                ctgliab: null,
                email: null,
                login: null,
                password: null,
                memmale: null,
                name: null,
                telephone: null,
                country: null,
                token: null,
                businessId: null,
                businessLogin: null,
                businessPassword: null,
            }

            var obj = detail.detail
            // Object.assign(optionObj, obj);

            for (let key in optionObj){
                if (obj.hasOwnProperty(key)){
                    optionObj[key] = obj[key]
                }
            }

            if (null != obj.company){
                const id = optionObj.id
                for (let key in optionObj){
                    if (obj.company.hasOwnProperty(key)){
                        optionObj[key] = obj.company[key]
                    }
                }
                // optionObj.wa = obj.company.wa
                // optionObj.siojournal = obj.company.siojournal
                optionObj.companyId = obj.company.id
                optionObj.id = id
            }

            optionObj.businessId = obj.id
            optionObj.businessLogin = obj.login
            optionObj.businessPassword = obj.password
            optionObj.telephone = obj.telephone

            userInfoRef.value.$patch(optionObj)
            userInfoRef.value.lastLoginDate = dateNow
            userInfoRef.value.selectCompanycode = userInfoRef.value.companycode

            for (const key in optionObj){
                cookie.setCookie(key, optionObj[key], {path: '/'})
            }

            loginSubmitObj.login.value = ""
            loginSubmitObj.password.value = ""

            // chatRoomUrl.value = `${shopopeeUrl}/enterChatRoom?login=${obj.login}&password=${obj.password}&tag=3dshopopee`

            // emits("login-check-complete", -1)

            if (null != detail.detail.company){
                if (detail.detail.company.webmem == 4){
                    initAccountVisible.value = true
                    return
                }
            }

            getUserCard()
            getBusinessInfo()
        }else if(detail.code === 102){
            myUtil.alertError(i18n.tkey("lang_user_not_found"))
        }else if(detail.code === 103){
            myUtil.alertError(i18n.tkey("lang_unvisivle_account"))
        }else if(detail.code === 104){
            myUtil.alertError(i18n.tkey("lang_account_stoped"))
        }else if(detail.code === 201){
            myUtil.alertError(detail.msg)
        }else if(detail.code === 202){
            myUtil.alertWarning(i18n.tkey("lang_activate_acc_pls"))
            emits("clickReActivate", loginSubmitObj.login.value)
        }else{
            myUtil.alertError(detail.msg)
        }
    }else{
        myUtil.alertError(i18n.tkey("lang_request_error"))
    }
}

function clickSubmitBtn(){
    if(waitPost.value == true){
        return
    }

    if (loginSubmitObj.login.value == ""){
        ElMessage({
            showClose: true,
            message: i18n.tkey("lang_login_not_empty"),
            type: 'error',
            appendTo: proxy.$refs.loginView
        })
    }else if (loginSubmitObj.password.value == ""){
        ElMessage({
            showClose: true,
            message: i18n.tkey("lang_password_not_empty"),
            type: 'error',
            appendTo: proxy.$refs.loginView
        })
    }else{
        waitPost.value = true
        shopopeeLogin(loginSubmitObj.login.value, loginSubmitObj.password.value, shopopeeLoginCallback)

    }

}

function getUserCard(){
    const obj = api.queryNewestMemberWorkById.getParams()

    obj.id = userInfoRef.value.id

    api.queryNewestMemberWorkById.send(obj, saveCard)

}

function saveCard(res){
    if (res.code == 200){
        if (null != res.detail){
            util.mergeObj(res.detail, cardInfoRef.value)

            emits("login-check-complete", -1)
          var ststa = cookie.getCookie("logined")
          if (!ststa){
            ElMessage({
              showClose: true,
              message: i18n.tkey("lang_login_success"),
              type: 'success',
              appendTo: proxy.$refs.loginView
            })
          }
        }
    }
}

function getBusinessInfo(){
    const request = userApi.queryBusinessBase
    const params = request.getParams()
    params.companycode = userInfoRef.value.companycode

    request.send(params, saveBusinessInfo)

}

function saveBusinessInfo(res){
    if (res.code == 200){
        if (null != res.detail){
            const obj = res.detail

            userInfoRef.value.businessId = obj.id
            userInfoRef.value.addinfo7 = obj.addinfo7
            userInfoRef.value.businessLogin = obj.login
            userInfoRef.value.businessPassword = obj.password
        }
    }
}

function goClickGoSignupBtn(){
    emits("clickGoSignup")
}

function loginFunc(login, password){
    loginSubmitObj.login.value = login
    loginSubmitObj.password.value = password

    clickSubmitBtn()

}

function saveCallback(){
    loginSubmitObj.login.value = userInfoRef.value.login
    loginSubmitObj.password.value = userInfoRef.value.password
    initAccountVisible.value = false

    clickSubmitBtn()
}

defineExpose({
    loginFunc
})

onMounted(()=>{
    if (props.autoLogin !== false){
        checkShopopeeCheck()
    }
})
</script>

<style scoped>
    ul {
      list-style: none;
      margin: 0;
      padding-left: 0;
    }

    .account-container {
      position: relative;
      width: 100%;
      /*padding: 10px;*/
      box-shadow: 5px 5px 10px #aaaaaa;
      background-color: #0e3326;
    }

    .account-info-inpus {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: center;
    }

    .account-info-inpus .col-12-li {
      width: 100%;
    }

    .account-info-inpus .col-9-li {
      width: 75%;
    }
</style>